import React, { useState } from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { History, ChevronRight } from 'lucide-react';

const DEFAULT_ART = 'https://images.pexels.com/photos/32589034/pexels-photo-32589034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100';

function formatTimeAgo(timestamp) {
  const now = Date.now() / 1000;
  const diff = now - timestamp;
  
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function SongHistory() {
  const { stationData } = useAudio();
  const history = stationData?.song_history || [];

  return (
    <div 
      className="glass rounded-2xl p-4"
      data-testid="song-history-panel"
    >
      <div className="flex items-center gap-2 mb-4">
        <History className="w-5 h-5" style={{ color: 'var(--primary)' }} />
        <h3 
          className="text-lg font-bold"
          style={{ fontFamily: 'Teko, sans-serif', color: 'var(--text-main)' }}
        >
          Recently Played
        </h3>
      </div>

      <div className="space-y-2 max-h-[300px] overflow-y-auto pr-1">
        {history.length === 0 ? (
          <p className="text-sm text-center py-4" style={{ color: 'var(--text-muted)' }}>
            No history available
          </p>
        ) : (
          history.map((item, index) => (
            <HistoryItem key={item.sh_id || index} item={item} />
          ))
        )}
      </div>
    </div>
  );
}

function HistoryItem({ item }) {
  const [imgError, setImgError] = useState(false);
  const song = item.song;
  const artUrl = imgError ? DEFAULT_ART : (song?.art || DEFAULT_ART);

  return (
    <div 
      className="group flex items-center gap-3 p-2 rounded-xl transition-all duration-200 hover:bg-white/5 cursor-pointer"
      data-testid={`history-item-${item.sh_id}`}
    >
      <img
        src={artUrl}
        alt={song?.title || 'Track'}
        className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
        onError={() => setImgError(true)}
      />
      
      <div className="flex-1 min-w-0">
        <p 
          className="font-medium text-sm truncate"
          style={{ color: 'var(--text-main)' }}
        >
          {song?.title || 'Unknown'}
        </p>
        <p 
          className="text-xs truncate"
          style={{ color: 'var(--text-muted)' }}
        >
          {song?.artist || 'Unknown Artist'}
        </p>
        <p 
          className="text-xs mt-0.5"
          style={{ color: 'var(--text-muted)' }}
        >
          {formatTimeAgo(item.played_at)}
        </p>
      </div>

      <ChevronRight 
        className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity"
        style={{ color: 'var(--text-muted)' }}
      />
    </div>
  );
}
